/**
 * Questions offered on an empty conversation (GOO-458), as translation keys: how-to and store
 * questions, so the merchant sees both kinds the agent answers.
 */
export const AGENT_CHAT_STARTERS = [
  'agent-chat.starters.create-chart',
  'agent-chat.starters.no-chart',
  'agent-chat.starters.not-showing',
  'agent-chat.starters.charts-left',
] as const;
